const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 0 });
const dateFormatter = new Intl.DateTimeFormat('en-AU');

export const formatCurrency = (numVal) => currencyFormatter.format(numVal ?? 0);
export const formatNumber = (numVal) => numberFormatter.format(numVal ?? 0);
export const formatDate = (val) =>
  !val ? '-' : val instanceof Date ? dateFormatter.format(val) : dateFormatter.format(new Date(val));

const yearsLabel = (years) => {
  if (!Number.isInteger(years)) return `${years.toFixed(1)} years`;
  return `${years} ${years === 1 ? 'year' : 'years'}`;
};

export const monthsToYears = (months) => {
  const parsedMonths = Number(months);
  if (!Number.isFinite(parsedMonths) || parsedMonths <= 0) return 0;
  return parsedMonths / 12;
};

export const yearsFormatter = (years) => {
  const parsedYears = Number(years);
  if (!Number.isFinite(parsedYears) || parsedYears <= 0) return 'N/A';
  return yearsLabel(parsedYears);
};

/** Formats a month count as whole years plus any remaining months (e.g. 170 → "14 years, 2 months"). */
export const formatTermFromMonths = (months) => {
  const parsedMonths = Number(months);
  if (!Number.isFinite(parsedMonths) || parsedMonths <= 0) return 'N/A';

  const wholeMonths = Math.round(parsedMonths);
  const years = Math.floor(wholeMonths / 12);
  const remainingMonths = wholeMonths % 12;

  if (years === 0) return `${remainingMonths} months`;
  if (remainingMonths === 0) return yearsLabel(years);
  return `${yearsLabel(years)}, ${remainingMonths} months`;
};

export const formatLoanTermDisplay = (loanTermMonths, isErhl) => {
  if (isErhl) {
    return formatTermFromMonths(loanTermMonths);
  }
  return `${loanTermMonths} months`;
};

export const formatErhlValue = (value, formatter = (v) => v) => {
  if (value === null || value === undefined) return 'N/A';
  if (typeof value === 'string' && value.trim() === '') return 'N/A';

  const numericValue = Number(value);
  const isNumericInput = typeof value === 'number' || (typeof value === 'string' && Number.isFinite(numericValue));

  if (isNumericInput) {
    if (!Number.isFinite(numericValue)) return 'N/A';
    if (numericValue === 0) return 'N/A';
  }

  return formatter(value);
};

/**
 * Converts an ENUM value of the format "some_string" to a presentable
 * format "Some string", with a special exception for Contract of Sale
 * abbreviations becoming uppercase
 * @param {*} val
 * @returns
 */
export const fromSnakeCase = (val) => {
  if (!val) return '';
  const sentence = val.replace(/_/g, ' ').trim();
  return (sentence.charAt(0).toUpperCase() + sentence.slice(1)).replace(' cos ', ' COS ');
};
